import { z } from 'zod';

export const EvolutionProposalKind = z.enum([
  'architecture-refinement',
  'doctrine-update',
  'new-substrate-proposal',
  'tier-policy-update',
  'agent-cluster-restructure',
]);

export const EvolutionProposal = z.object({
  id: z.string(),
  kind: EvolutionProposalKind,
  headline: z.string(),
  body: z.string(),
  evidence: z.array(
    z.object({
      kind: z.enum(['agent-eval-pattern', 'flywheel-insight', 'kscan-signal', 'operator-feedback']),
      ref: z.string(),
    })
  ),
  proposedActions: z.array(z.string()),
  confidence: z.number().min(0).max(1),
  generatedAt: z.string(),
  decisionStatus: z.enum(['pending', 'accepted', 'rejected', 'deferred']).default('pending'),
  decisionAt: z.string().nullable().default(null),
  decisionByUserId: z.string().nullable().default(null),
  decisionRationale: z.string().nullable().default(null),
  correlationId: z.string(),
});
